import { api } from './api';
import type { Notification, ApiResponse, PagedResult } from '@/types';

export const notificationService = {
  getAll: async (page = 1, pageSize = 20): Promise<ApiResponse<PagedResult<Notification>>> => {
    const response = await api.get(`/notifications?pageNumber=${page}&pageSize=${pageSize}`);
    return response.data;
  },
  getUnread: async (): Promise<ApiResponse<Notification[]>> => {
    const response = await api.get('/notifications/unread');
    return response.data;
  },
  markAsRead: async (id: number): Promise<ApiResponse<boolean>> => {
    const response = await api.put(`/notifications/${id}/read`);
    return response.data;
  },
  markAllAsRead: async (): Promise<ApiResponse<boolean>> => {
    const response = await api.put('/notifications/mark-all-read');
    return response.data;
  },
  delete: async (id: number): Promise<ApiResponse<boolean>> => {
    const response = await api.delete(`/notifications/${id}`);
    return response.data;
  },
  getCount: async (): Promise<ApiResponse<number>> => {
    const response = await api.get('/notifications/count');
    return response.data;
  },
};
